import React, { forwardRef } from 'react';

export const BulletIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="4"
    viewBox="0 0 4 4"
    fill="none"
  >
    <circle cx="2" cy="2" r="2" fill="#183558" />
  </svg>
);

export const CarvanaCircleIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    ref={ref}
    height={20}
    width={20}
    {...props}
  >
    <g clipPath="url(#clip0_6628_166590)">
      <path
        d="M19.9848 9.99239C19.9848 15.5118 15.5118 19.9848 9.99103 19.9848C4.47026 19.9848 0 15.5122 0 9.99239C0 4.47253 4.473 0 9.98966 0C15.5063 0 19.9848 4.47481 19.9848 9.99239Z"
        fill="#228BE6"
      />
      <path
        d="M10.0038 4.62587C9.46943 4.62242 8.93559 4.65948 8.40684 4.73671C8.07057 4.78233 7.80456 4.87037 7.69141 4.9283L7.7343 4.94837C7.89696 5.01395 8.06616 5.06211 8.23893 5.09206C8.68334 5.17736 9.31072 5.23301 10.0033 5.23301C10.5368 5.23647 11.0697 5.19942 11.5976 5.12217C11.9338 5.07427 12.1998 4.98531 12.313 4.9283L12.2701 4.90823C12.1084 4.84338 11.9401 4.79612 11.7682 4.76728C11.3243 4.68152 10.6969 4.62587 10.0038 4.62587ZM10.0038 5.60294C9.45209 5.60653 8.90091 5.56872 8.35483 5.48982C7.89855 5.41182 7.57643 5.33382 7.38343 5.1623C7.34973 5.13275 7.32252 5.09655 7.30351 5.05595C7.28451 5.01537 7.27412 4.97128 7.27301 4.92648C7.27384 4.88221 7.28412 4.83865 7.30316 4.79868C7.3222 4.75871 7.34957 4.72328 7.38343 4.69475C7.44186 4.64121 7.50878 4.59774 7.58145 4.56612C7.77087 4.48772 7.9689 4.43198 8.17141 4.40008C8.64593 4.30885 9.29338 4.25411 10.0065 4.25411C10.5575 4.25074 11.1079 4.28855 11.6532 4.36724C12.1095 4.44524 12.4289 4.52369 12.6274 4.69749C12.6625 4.72529 12.6909 4.76068 12.7104 4.801C12.73 4.84133 12.7401 4.88555 12.7401 4.93035C12.7401 4.97516 12.73 5.01938 12.7104 5.0597C12.6909 5.10003 12.6625 5.13541 12.6274 5.16322C12.5687 5.21457 12.5027 5.25699 12.4316 5.28912C12.242 5.3673 12.044 5.42392 11.8417 5.45789C11.3612 5.54775 10.717 5.60294 10.0038 5.60294Z"
        fill="#FAB005"
      />
      <path
        d="M14.2009 9.81871C14.0184 9.59704 13.6963 9.05833 13.6612 8.98533L13.7041 8.97537C13.7041 8.97537 14.7334 8.9197 14.55 8.5648C14.55 8.5648 14.3492 8.13423 13.5918 8.13423C13.5583 8.13347 13.5247 8.13514 13.4914 8.13925L13.4887 8.13651C13.4513 8.13651 13.4061 8.15156 13.386 8.4102C12.7609 7.24425 12.3266 7.00249 12.3266 7.00249C12.2435 6.95459 12.186 6.92448 11.9725 6.88161C11.759 6.83873 10.12 6.82642 9.98452 6.82642H9.97448C9.8376 6.82642 8.20231 6.84147 7.9865 6.88161C7.77068 6.92175 7.71273 6.95459 7.63243 7.00249C7.63243 7.00249 7.19807 7.24425 6.57298 8.4102C6.55062 8.15065 6.50545 8.13651 6.46758 8.13651V8.13925C6.43244 8.13651 6.39959 8.13423 6.36674 8.13423C5.61115 8.13423 5.41313 8.5648 5.41313 8.5648C5.22742 8.9197 6.25632 8.97537 6.25632 8.97537L6.30195 8.98533C6.14214 9.27506 5.96271 9.55354 5.76491 9.81871C5.73252 9.85887 5.54134 10.0806 5.47107 10.2471C5.41367 10.4034 5.38642 10.5691 5.39077 10.7356C5.39853 11.0093 5.42864 12.1985 5.42864 12.1985V13.6992C5.42864 13.7877 5.48385 13.8557 5.55412 13.8557H6.73632C6.80659 13.8557 6.86453 13.7849 6.86453 13.6992V13.5131H13.1013V13.6992C13.1013 13.7877 13.1593 13.8557 13.2268 13.8557H14.4095C14.4797 13.8557 14.5349 13.7849 14.5349 13.6992V12.1985C14.5349 12.1985 14.5651 11.0075 14.5724 10.7356C14.5805 10.5689 14.5531 10.4024 14.4921 10.2471C14.4218 10.0783 14.2311 9.85887 14.2009 9.81871ZM7.00644 8.67065C7.00644 8.67065 7.4586 7.65795 7.81722 7.22509C7.81722 7.22509 8.4852 7.19499 9.38133 7.18723L9.35349 7.25793V7.4112C9.35334 7.42511 9.35593 7.43891 9.36117 7.45181C9.36634 7.4647 9.3741 7.47642 9.38391 7.48627C9.3938 7.49613 9.40543 7.50393 9.41828 7.50921C9.43121 7.51449 9.44498 7.51715 9.45889 7.51702H10.4983C10.5124 7.51739 10.5264 7.51492 10.5396 7.50976C10.5527 7.5046 10.5647 7.49686 10.5748 7.48699C10.5848 7.47712 10.5929 7.46532 10.5983 7.4523C10.6038 7.43928 10.6065 7.42531 10.6064 7.4112V7.25793L10.5786 7.18723C11.4747 7.19499 12.1427 7.22509 12.1427 7.22509C12.5018 7.65795 12.9535 8.67065 12.9535 8.67065C13.0187 8.83392 12.8805 8.83392 12.8805 8.83392H7.07944C7.07944 8.83392 6.94119 8.83392 7.00644 8.67065ZM5.91138 11.1411C5.68324 11.0827 5.66043 10.9445 5.66043 10.9445C5.63955 10.7429 5.66355 10.5392 5.73069 10.3479C5.80598 10.1485 6.00172 10.1262 6.14453 10.1312C6.31518 10.1362 6.81754 10.456 6.81754 10.456C7.20126 10.6548 7.25647 11.34 7.25647 11.34C6.80446 11.3039 6.35539 11.2375 5.91229 11.1411H5.91138ZM12.2773 11.3802C11.5842 11.4381 10.5891 11.4431 9.98041 11.4431C9.37174 11.4431 8.37615 11.4381 7.68581 11.3802C7.68581 11.3802 7.4878 10.9595 7.78619 10.9495C7.82908 10.9468 8.72019 10.9167 9.98041 10.9145C11.2406 10.9122 12.134 10.9468 12.1742 10.9495C12.4767 10.9595 12.2782 11.3802 12.2782 11.3802H12.2773ZM14.3004 10.9468C14.3004 10.9468 14.2753 11.0837 14.0495 11.1434C13.6054 11.2375 13.1561 11.3049 12.7039 11.345C12.7039 11.345 12.7591 10.6608 13.1433 10.461C13.1433 10.461 13.6452 10.1417 13.8136 10.1362C13.9591 10.1312 14.1549 10.1535 14.2279 10.3529C14.2973 10.543 14.3225 10.7465 14.3013 10.9477L14.3004 10.9468Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6628_166590">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export const CheckMarkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
  >
    <path
      d="M1 5.12121C1.93726 6.11527 3.4 7.66667 3.4 7.66667L9 1"
      stroke="#183558"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChipIcon = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    className={className}
  >
    <path d="M5 5L9 1" stroke="#00AED9" strokeLinecap="round" />
    <path d="M5 5L1 1" stroke="#00AED9" strokeLinecap="round" />
  </svg>
);
